import React, { Component } from "react"
import {
  Container,
} from "reactstrap"

class AcaCategorySections extends Component {
  render() {
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            <h3>Main AcaCategorySections</h3>
          </Container>
        </div>
      </React.Fragment>
    )
  }
}

export default AcaCategorySections;
